export default {
  // Header
  'header.total': 'Total',
  'header.balanceSummary': 'Resumen de Saldos',
  'header.showValues': 'Mostrar valores',
  'header.hideValues': 'Ocultar valores',
  'header.digitalAccount': 'Cuenta Digital',
  'header.availableBalance': 'Saldo disponible',
  'header.viewStatement': 'Ver extracto',
  'header.incentivePoints': 'Puntos de Incentivo',
  'header.totalAccumulated': 'Total acumulado',
  'header.totalEquity': 'Patrimonio Total',
  'header.accountPlusPoints': 'Cuenta + Puntos convertidos',
  'header.notifications': 'Notificaciones',
  'header.markAllAsRead': 'Marcar todas como leídas',
  'header.noNotifications': 'Sin notificaciones',
  'header.viewAllNotifications': 'Ver todas las notificaciones',
  'header.deleteNotification': 'Eliminar notificación',
  'header.myProfile': 'Mi Perfil',
  'header.companyData': 'Datos de la Empresa',
  'header.settings': 'Configuración',
  'header.logout': 'Salir',
  'header.switchCompany': 'Cambiar empresa',
  'header.selectCompany': 'Seleccione la empresa:',

  // Sidebar
  'sidebar.home': 'Inicio',
  'sidebar.incentive': 'Incentivo',
  'sidebar.dashboard': 'Panel',
  'sidebar.campaigns': 'Campañas',
  'sidebar.participants': 'Participantes',
  'sidebar.participantsList': 'Lista de Participantes',
  'sidebar.registrations': 'Registros',
  'sidebar.sendInvites': 'Enviar Invitaciones',
  'sidebar.performance': 'Rendimiento',
  'sidebar.points': 'Puntos',
  'sidebar.scoring': 'Puntuación',
  'sidebar.buyPoints': 'Comprar Puntos',
  'sidebar.distribution': 'Distribución',
  'sidebar.deposit': 'Depósito',
  'sidebar.pointsStatement': 'Extracto de Puntos',
  'sidebar.digitalAccountStatement': 'Extracto Cuenta Digital',
  'sidebar.rewards': 'Recompensas',
  'sidebar.simulator': 'Simulador',
  'sidebar.gamification': 'Gamificación',
  'sidebar.levels': 'Niveles y Progresión',
  'sidebar.badges': 'Insignias',
  'sidebar.missions': 'Misiones y Desafíos',
  'sidebar.games': 'Juegos y Sorteos',
  'sidebar.xpRules': 'Reglas de XP',
  'sidebar.logs': 'Registros e Historial',
  'sidebar.analytics': 'Analíticas',
  'sidebar.support': 'Soporte',

  // Common buttons
  'button.new': 'Nuevo',
  'button.edit': 'Editar',
  'button.delete': 'Eliminar',
  'button.save': 'Guardar',
  'button.cancel': 'Cancelar',
  'button.confirm': 'Confirmar',
  'button.close': 'Cerrar',
  'button.search': 'Buscar',
  'button.filter': 'Filtrar',
  'button.export': 'Exportar',
  'button.import': 'Importar',
  'button.view': 'Ver',
  'button.download': 'Descargar',
  'button.upload': 'Subir',
  'button.add': 'Añadir',
  'button.remove': 'Eliminar',
  'button.back': 'Volver',
  'button.next': 'Siguiente',
  'button.previous': 'Anterior',
  'button.finish': 'Finalizar',
  'button.approve': 'Aprobar',
  'button.reject': 'Rechazar',
  'button.send': 'Enviar',

  // Common labels
  'label.name': 'Nombre',
  'label.email': 'Email',
  'label.phone': 'Teléfono',
  'label.cpf': 'CPF',
  'label.cnpj': 'CNPJ',
  'label.date': 'Fecha',
  'label.startDate': 'Fecha Inicial',
  'label.endDate': 'Fecha Final',
  'label.status': 'Estado',
  'label.type': 'Tipo',
  'label.description': 'Descripción',
  'label.value': 'Valor',
  'label.quantity': 'Cantidad',
  'label.total': 'Total',
  'label.actions': 'Acciones',
  'label.search': 'Buscar',
  'label.filter': 'Filtrar',
  'label.all': 'Todos',
  'label.active': 'Activo',
  'label.inactive': 'Inactivo',
  'label.pending': 'Pendiente',
  'label.approved': 'Aprobado',
  'label.rejected': 'Rechazado',
  'label.completed': 'Completado',
  'label.inProgress': 'En Progreso',
  'label.scheduled': 'Programado',
  'label.cancelled': 'Cancelado',

  // Notifications
  'notification.newCampaign': 'Nueva campaña disponible',
  'notification.pointsCredited': 'Puntos acreditados en su cuenta',
  'notification.goalAchieved': '¡Meta mensual alcanzada!',
  'notification.newParticipant': 'Nuevo participante añadido',
  'notification.rewardAvailable': 'Premio disponible para canje',

  // Time
  'time.minutesAgo': 'min atrás',
  'time.hoursAgo': 'hora atrás',
  'time.hoursAgoPlural': 'horas atrás',
  'time.daysAgo': 'día atrás',
  'time.daysAgoPlural': 'días atrás',

  // Messages
  'message.success': '¡Operación realizada con éxito!',
  'message.error': 'Ocurrió un error. Inténtelo de nuevo.',
  'message.confirmDelete': '¿Está seguro de que desea eliminar?',
  'message.noData': 'No se encontraron datos',
  'message.loading': 'Cargando...',
  'message.saving': 'Guardando...',

  // Participants
  'participants.title': 'Participantes',
  'participants.list': 'Lista de Participantes',
  'participants.registrations': 'Registros',
  'participants.sendInvites': 'Enviar Invitaciones',
  'participants.performance': 'Rendimiento',
  'participants.totalParticipants': 'Total de Participantes',
  'participants.activeParticipants': 'Participantes Activos',
  'participants.newThisMonth': 'Nuevos este Mes',
  'participants.averagePoints': 'Promedio de Puntos',
  'participants.searchPlaceholder': 'Buscar por nombre, email o CPF...',
  'participants.filterByStatus': 'Filtrar por Estado',
  'participants.filterByLevel': 'Filtrar por Nivel',
  'participants.exportList': 'Exportar Lista',
  'participants.importParticipants': 'Importar Participantes',
  'participants.newParticipant': 'Nuevo Participante',
  'participants.viewProfile': 'Ver Perfil',
  'participants.viewHistory': 'Ver Historial',
  'participants.editParticipant': 'Editar Participante',
  'participants.deleteParticipant': 'Eliminar Participante',
  'participants.points': 'Puntos',
  'participants.level': 'Nivel',
  'participants.registrationDate': 'Fecha de Registro',
  'participants.lastAccess': 'Último Acceso',

  // Dashboard
  'dashboard.title': 'Panel de Incentivos',
  'dashboard.subtitle': 'Siga el rendimiento de sus campañas de incentivo',
  'dashboard.activeCampaigns': 'Campañas Activas',
  'dashboard.activeParticipants': 'Participantes Activos',
  'dashboard.distributedPoints': 'Puntos Distribuidos',
  'dashboard.redeemedRewards': 'Premios Canjeados',
  'dashboard.vsPreviousPeriod': 'vs período anterior',
  'dashboard.featuredCampaigns': 'Campañas Destacadas',
  'dashboard.viewAll': 'Ver todas',
  'dashboard.participantsRanking': 'Clasificación de Participantes',
  'dashboard.viewFullRanking': 'Ver clasificación completa',
  'dashboard.campaignPerformance': 'Rendimiento de Campañas',
  'dashboard.points': 'Puntos',
  'dashboard.participation': 'Participación',
  'dashboard.redemptions': 'Canjes',
  'dashboard.chartPlaceholder': 'El gráfico de rendimiento se mostrará aquí',
  'dashboard.chartSubtitle': 'Datos en tiempo real de campañas activas',
  'dashboard.quickActions': 'Acciones Rápidas',
  'dashboard.createCampaign': 'Crear Campaña',
  'dashboard.newIncentiveCampaign': 'Nueva campaña de incentivos',
  'dashboard.distributePoints': 'Distribuir Puntos',
  'dashboard.sendPointsToParticipants': 'Enviar puntos a participantes',
  'dashboard.generateReport': 'Generar Informe',
  'dashboard.performanceReport': 'Informe de rendimiento',
  'dashboard.newCampaign': 'Nueva Campaña',
  'dashboard.thisWeek': 'Esta Semana',
  'dashboard.thisMonth': 'Este Mes',
  'dashboard.thisQuarter': 'Este Trimestre',
  'dashboard.thisYear': 'Este Año',
  'dashboard.active': 'Activa',
  'dashboard.paused': 'Pausada',
  'dashboard.participants': 'participantes',

  // Participantes - Lista
  participants: {
    title: 'Participantes',
    subtitle: 'Gestione los participantes del programa de incentivos',
    tabs: {
      list: 'Lista de Participantes',
      registrations: 'Registros',
      invites: 'Enviar Invitaciones',
      performance: 'Rendimiento'
    },
    filters: {
      search: 'Buscar por nombre, email o ID...',
      status: 'Estado',
      all: 'Todos',
      active: 'Activos',
      inactive: 'Inactivos',
      pending: 'Pendientes',
      segment: 'Segmento',
      allSegments: 'Todos los Segmentos',
      campaign: 'Campaña',
      allCampaigns: 'Todas las Campañas'
    },
    table: {
      participant: 'Participante',
      email: 'Email',
      segment: 'Segmento',
      points: 'Puntos',
      level: 'Nivel',
      status: 'Estado',
      registrationDate: 'Fecha de Registro',
      actions: 'Acciones'
    },
    actions: {
      viewProfile: 'Ver Perfil',
      editData: 'Editar Datos',
      managePoints: 'Gestionar Puntos',
      viewHistory: 'Ver Historial',
      deactivate: 'Desactivar',
      activate: 'Activar',
      sendMessage: 'Enviar Mensaje'
    },
    stats: {
      total: 'Total de Participantes',
      active: 'Activos',
      newThisMonth: 'Nuevos este Mes',
      averagePoints: 'Promedio de Puntos'
    },
    buttons: {
      newParticipant: 'Nuevo Participante',
      importCSV: 'Importar CSV',
      exportData: 'Exportar Datos',
      bulkActions: 'Acciones Masivas'
    }
  },

  // Participantes - Registros
  registrations: {
    title: 'Registros de Participantes',
    subtitle: 'Gestione solicitudes de registro y aprobaciones',
    filters: {
      search: 'Buscar por nombre o email...',
      status: 'Estado',
      all: 'Todos',
      pending: 'Pendientes',
      approved: 'Aprobados',
      rejected: 'Rechazados',
      period: 'Período',
      last7days: 'Últimos 7 días',
      last30days: 'Últimos 30 días',
      last90days: 'Últimos 90 días'
    },
    table: {
      name: 'Nombre',
      email: 'Email',
      phone: 'Teléfono',
      segment: 'Segmento',
      requestDate: 'Fecha de Solicitud',
      status: 'Estado',
      actions: 'Acciones'
    },
    actions: {
      viewDetails: 'Ver Detalles',
      approve: 'Aprobar',
      reject: 'Rechazar',
      requestAdjustment: 'Solicitar Ajuste'
    },
    stats: {
      pending: 'Pendientes',
      approved: 'Aprobados Hoy',
      rejected: 'Rechazados',
      approvalRate: 'Tasa de Aprobación'
    }
  },

  // Participantes - Enviar Invitaciones
  invites: {
    title: 'Enviar Invitaciones',
    subtitle: 'Invite nuevos participantes al programa',
    form: {
      inviteType: 'Tipo de Invitación',
      individual: 'Individual',
      bulk: 'Masiva',
      name: 'Nombre Completo',
      email: 'Email',
      phone: 'Teléfono (opcional)',
      segment: 'Segmento',
      selectSegment: 'Seleccione el segmento',
      campaign: 'Campaña (opcional)',
      selectCampaign: 'Seleccione la campaña',
      message: 'Mensaje Personalizado (opcional)',
      messagePlaceholder: 'Escriba un mensaje de bienvenida...',
      csvFile: 'Archivo CSV',
      uploadCSV: 'Subir CSV',
      downloadTemplate: 'Descargar Plantilla CSV'
    },
    buttons: {
      sendInvite: 'Enviar Invitación',
      sendInvites: 'Enviar Invitaciones',
      addAnother: 'Agregar Otro',
      clear: 'Limpiar'
    },
    stats: {
      sent: 'Invitaciones Enviadas',
      accepted: 'Aceptadas',
      pending: 'Pendientes',
      acceptanceRate: 'Tasa de Aceptación'
    },
    recentInvites: {
      title: 'Invitaciones Recientes',
      email: 'Email',
      sentDate: 'Fecha de Envío',
      status: 'Estado',
      actions: 'Acciones',
      resend: 'Reenviar',
      cancel: 'Cancelar'
    }
  },

  // Participantes - Rendimiento
  performance: {
    title: 'Rendimiento de Participantes',
    subtitle: 'Análisis detallado de desempeño y compromiso',
    filters: {
      period: 'Período',
      last7days: 'Últimos 7 días',
      last30days: 'Últimos 30 días',
      last90days: 'Últimos 90 días',
      thisYear: 'Este Año',
      segment: 'Segmento',
      allSegments: 'Todos los Segmentos',
      campaign: 'Campaña',
      allCampaigns: 'Todas las Campañas'
    },
    topPerformers: {
      title: 'Mejores Participantes',
      position: 'Posición',
      participant: 'Participante',
      points: 'Puntos',
      missions: 'Misiones',
      rewards: 'Canjes'
    },
    metrics: {
      totalPoints: 'Puntos Totales Distribuidos',
      averagePoints: 'Promedio de Puntos por Participante',
      completedMissions: 'Misiones Completadas',
      redemptionRate: 'Tasa de Canje'
    },
    engagement: {
      title: 'Compromiso',
      daily: 'Diario',
      weekly: 'Semanal',
      monthly: 'Mensual'
    }
  },

  // Gamificación - Niveles
  levels: {
    title: 'Niveles y Progresión',
    subtitle: 'Configure los niveles de progresión de participantes',
    buttons: {
      newLevel: 'Nuevo Nivel',
      reorder: 'Reordenar Niveles'
    },
    table: {
      level: 'Nivel',
      name: 'Nombre',
      xpRequired: 'XP Requerido',
      benefits: 'Beneficios',
      participants: 'Participantes',
      actions: 'Acciones'
    },
    stats: {
      totalLevels: 'Total de Niveles',
      averageXP: 'XP Promedio por Nivel',
      maxLevel: 'Nivel Máximo Alcanzado'
    }
  },

  // Gamificación - Insignias
  badges: {
    title: 'Insignias y Logros',
    subtitle: 'Gestione insignias y logros del sistema',
    buttons: {
      newBadge: 'Nueva Insignia',
      categories: 'Categorías'
    },
    filters: {
      search: 'Buscar insignias...',
      category: 'Categoría',
      allCategories: 'Todas las Categorías',
      rarity: 'Rareza',
      allRarities: 'Todas las Rarezas'
    },
    table: {
      badge: 'Insignia',
      description: 'Descripción',
      category: 'Categoría',
      rarity: 'Rareza',
      criteria: 'Criterio',
      earned: 'Obtenidas',
      actions: 'Acciones'
    }
  },

  // Gamificación - Reglas XP
  xpRules: {
    title: 'Reglas de XP',
    subtitle: 'Configure cómo los participantes ganan experiencia',
    buttons: {
      newRule: 'Nueva Regla',
      categories: 'Categorías de Acciones'
    },
    table: {
      action: 'Acción',
      category: 'Categoría',
      xpAmount: 'Cantidad de XP',
      limit: 'Límite',
      status: 'Estado',
      actions: 'Acciones'
    },
    stats: {
      totalRules: 'Total de Reglas',
      averageXP: 'XP Promedio por Acción',
      mostUsed: 'Regla Más Usada'
    }
  },

  // Gamificación - Logs
  logs: {
    title: 'Registros de Actividades',
    subtitle: 'Historial completo de acciones y eventos del sistema',
    filters: {
      search: 'Buscar en registros...',
      type: 'Tipo de Evento',
      allTypes: 'Todos los Tipos',
      period: 'Período',
      last24h: 'Últimas 24h',
      last7days: 'Últimos 7 días',
      last30days: 'Últimos 30 días',
      user: 'Usuario',
      allUsers: 'Todos los Usuarios'
    },
    table: {
      timestamp: 'Fecha/Hora',
      user: 'Usuario',
      action: 'Acción',
      details: 'Detalles',
      ip: 'IP',
      status: 'Estado'
    }
  },

  // Gamificación - Analytics
  analytics: {
    title: 'Analytics e Informes',
    subtitle: 'Análisis detallado de datos y métricas de gamificación',
    tabs: {
      overview: 'Resumen',
      engagement: 'Compromiso',
      progression: 'Progresión',
      rewards: 'Recompensas'
    },
    metrics: {
      totalXP: 'XP Total Distribuido',
      activeUsers: 'Usuarios Activos',
      completionRate: 'Tasa de Finalización',
      averageLevel: 'Nivel Promedio'
    }
  },

  // Incentivo - Campañas
  campaigns: {
    title: 'Campañas',
    subtitle: 'Gestione sus campañas de incentivo',
    buttons: {
      newCampaign: 'Nueva Campaña',
      templates: 'Plantillas'
    },
    filters: {
      search: 'Buscar campañas...',
      status: 'Estado',
      all: 'Todas',
      active: 'Activas',
      scheduled: 'Programadas',
      completed: 'Completadas',
      paused: 'Pausadas'
    },
    table: {
      campaign: 'Campaña',
      period: 'Período',
      participants: 'Participantes',
      budget: 'Presupuesto',
      distributed: 'Distribuido',
      status: 'Estado',
      actions: 'Acciones'
    },
    stats: {
      active: 'Campañas Activas',
      totalBudget: 'Presupuesto Total',
      distributed: 'Distribuido',
      participants: 'Participantes'
    }
  },

  // Incentivo - Puntuación
  scoring: {
    title: 'Puntuación',
    subtitle: 'Gestione reglas y distribución de puntos',
    buttons: {
      newRule: 'Nueva Regla',
      distribute: 'Distribuir Puntos'
    }
  },

  // Incentivo - Recompensas
  rewards: {
    title: 'Recompensas',
    subtitle: 'Catálogo de premios y canjes',
    buttons: {
      newReward: 'Nueva Recompensa',
      categories: 'Categorías'
    },
    filters: {
      search: 'Buscar recompensas...',
      category: 'Categoría',
      allCategories: 'Todas las Categorías',
      availability: 'Disponibilidad',
      all: 'Todas',
      available: 'Disponibles',
      outOfStock: 'Agotadas'
    }
  },

  // Incentivo - Extracto de Puntos
  pointsStatement: {
    title: 'Extracto de Puntos',
    subtitle: 'Historial de movimientos de puntos',
    filters: {
      search: 'Buscar por participante...',
      period: 'Período',
      type: 'Tipo de Movimiento',
      allTypes: 'Todos los Tipos'
    }
  },

  // Incentivo - Simulador
  simulator: {
    title: 'Simulador de Campañas',
    subtitle: 'Simule resultados y costos de campañas',
    form: {
      campaignName: 'Nombre de la Campaña',
      participants: 'Número de Participantes',
      duration: 'Duración (días)',
      pointsPerAction: 'Puntos por Acción',
      estimatedActions: 'Acciones Estimadas por Participante'
    },
    results: {
      title: 'Resultados de la Simulación',
      totalPoints: 'Total de Puntos',
      estimatedCost: 'Costo Estimado',
      roi: 'ROI Estimado'
    }
  },

  // Común
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    loading: 'Cargando...',
    noData: 'No se encontraron datos',
    confirm: 'Confirmar',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    close: 'Cerrar',
    actions: 'Acciones',
    status: 'Estado',
    date: 'Fecha',
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    description: 'Descripción'
  },

  menu: {
    home: 'Inicio',
    campaigns: 'Campañas',
    missions: 'Misiones',
    levels: 'Niveles',
    badges: 'Insignias',
    games: 'Juegos',
    training: 'Entrenamiento',
    social: 'Social',
    rewards: 'Recompensas',
    statement: 'Extracto',
    support: 'Soporte',
  }
};